// Run Spinner Loader
function runSpinnerLoader() {
  const spinner_loader = document.querySelector('.spinner-loader');
  spinner_loader.classList.remove('hidden');
  spinner_loader.classList.add('flex');
}

// Gift for products list
let is_gift_for_products_list = document.querySelector(".byteex_cart_drawer").dataset.isGiftForProductsList === "true";
if (is_gift_for_products_list) {
  function addGiftToCart() {
    const giftElement = document.getElementById("auto-add-gift");
    const giftElementToRemove = document.getElementById("auto-remove-gift");    

    if (giftElementToRemove) {
      const giftIdToRemove = giftElementToRemove.dataset.giftId;
      const giftProductToRemove = document.querySelector(`[data-line-item-key^="${giftIdToRemove}:"]`);

      if (giftProductToRemove) {
        const lineItemKey = giftProductToRemove.getAttribute("data-line-item-key");
        let formData = {
          updates: {
            [lineItemKey]: 0
          }
        };
        
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => {
          updateCartDrawer();
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }      
    }
    
    if (giftElement) {
      const giftId = giftElement.dataset.giftId;

      let formData = {
        items: [
          {
            id: giftId,
            quantity: 1,
            properties: {
              "Gift": "Gift for Products List"
            },
          },
        ],
      };
    
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          updateCartDrawer();
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }

  document.addEventListener("DOMContentLoaded", addGiftToCart);

  const cartDrawer = document.querySelector(".byteex_cart_drawer");
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      addGiftToCart();
    });

    observer.observe(cartDrawer, { childList: true, subtree: true });
  }
}

// Cart Color Picker Listeners
function addCartColorChangeListeners(index, type) {
  const color_picker_modal = document.querySelector(`.picker-modal-${index}`);
  const sorry_label = color_picker_modal.previousElementSibling;
  const selected_colors = color_picker_modal.querySelectorAll('.byteex-cart-selected-color');
  const remove_color_buttons = color_picker_modal.querySelectorAll('.byteex-cart-remove-color');
  const colors_variants = color_picker_modal.querySelectorAll('.byteex-cart-color-item');
  const submit_button = color_picker_modal.querySelector('.byteex-cart-picker-submit');
  const colors_filters = color_picker_modal.querySelectorAll('.byteex-cart-color-filter');

  function filterColors(event) {
    const filter_button = event.currentTarget;
    const filter_value = filter_button.dataset.value;

    colors_filters.forEach((filter) => {
      filter.style.fontWeight = '400';
    });
    filter_button.style.fontWeight = '700';

    colors_variants.forEach((variant) => {
      const variant_filters = variant.dataset.filter.toLowerCase();
      
      variant.style.display = 'flex';
      if (!variant_filters.includes(filter_value) && filter_value != 'All') {
        variant.style.display = 'none';
      }
    });
  }

  function removeColorHandler(event) {
    const button = event.currentTarget;
    button.style.display = 'none';
    const parent = button.parentElement;
    parent.dataset.empty = 'true';
    parent.dataset.id = 'empty';
    parent.dataset.image = 'empty';
    parent.dataset.color = 'empty';

    const image_element = parent.querySelector('img');
    if (image_element) {
      image_element.style.display = 'none';
    }

    const text_element = parent.nextElementSibling;
    if (text_element) {
      text_element.textContent = '';
    }

    const out_of_stock_label = parent.querySelector('.out-of-stock-label');
    if (out_of_stock_label) {
      out_of_stock_label.style.display = 'none';
    }
  }

  function selectColorHandler(event) {
    const button = event.currentTarget;
    const id = button.dataset.id;            
    const image = button.dataset.image;            
    const color = button.dataset.color;

    for (const color_variant of selected_colors) {
      const is_empty = color_variant.dataset.empty;

      if (is_empty === 'true') {
        color_variant.dataset.id = id;
        color_variant.dataset.image = image;
        color_variant.dataset.color = color;

        const remove_button = color_variant.querySelector('.byteex-cart-remove-color');
        if (remove_button) {
          remove_button.style.display = 'block';
        }

        const image_element = color_variant.querySelector('img');
        if (image_element) {
          image_element.src = image;
          image_element.style.display = 'block';
        }

        const out_of_stock_label = color_variant.querySelector('.out-of-stock-label');
        if (out_of_stock_label) {
          out_of_stock_label.style.display = 'none';
        }

        const text_element = color_variant.nextElementSibling;
        if (text_element) {
          text_element.textContent = color;
        }

        color_variant.dataset.empty = 'false';
        break;
      }
    }
  }

  async function submitHandler(event) {
    const button = event.currentTarget;
    const key = button.dataset.key;
    const productHandle = button.dataset.productHandle;

    let is_all_selected = true;
    let changes = {
      id: key,
      properties: {}
    };

    let index = 1;
    for (const color_variant of selected_colors) {
      const is_empty = color_variant.dataset.empty;

      if (is_empty === 'true') {
        is_all_selected = false;
        break;
      }
      
      changes.properties[`_id${index}.`] = color_variant.dataset.id;
      changes.properties[`_${index}.`] = color_variant.dataset.image; 
      changes.properties[`${type} ${index}`] = color_variant.dataset.color;

      index++;
    }

    if (is_all_selected) {          
      const text = button.querySelector('.byteex-cart-picker-submit-text');
      const loader = button.querySelector('.loader');   
      
      text.style.display = 'none';
      loader.style.display = 'block';

      const variantIds = await getGiftsVariantIds(productHandle);
      variantIds.forEach((id, index) => {
        changes.properties[`_discount_iq_gift_${index + 1}`] = id;
      });
    
      try {
        await fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(changes),
        });

        colors_filters.forEach((filter) => {
          filter.removeEventListener("click", filterColors);
        });
        
        remove_color_buttons.forEach((button) => {
          button.removeEventListener("click", removeColorHandler);
        });

        colors_variants.forEach((color_variant) => {
          color_variant.removeEventListener("click", selectColorHandler);
        });

        submit_button.removeEventListener("click", submitHandler);

        await updateCartDrawer();

      } catch (error) {
        console.error("Error:", error);
      }
    }
  }

  function sorryLabelCloseHandler(event) {
    const button = event.currentTarget;
    if (button) {
      button.style.display = 'none';
    }
  }

  colors_filters.forEach((filter) => {
    filter.addEventListener("click", filterColors);
  });

  remove_color_buttons.forEach((button) => {
    button.addEventListener("click", removeColorHandler);
  });

  colors_variants.forEach((color_variant) => {
    color_variant.addEventListener("click", selectColorHandler);
  });

  if (submit_button) {
    submit_button.addEventListener("click", submitHandler);
  }

  if (sorry_label) {
    sorry_label.addEventListener("click", sorryLabelCloseHandler);
  }

  const nailPicker = document.querySelector(`.picker-${index}`);
  const overlay = document.querySelector('.cart-overlay');
  overlay.addEventListener('click', () => {
    colors_filters.forEach((filter) => {
      filter.removeEventListener("click", filterColors);
    });
    
    remove_color_buttons.forEach((button) => {
      button.removeEventListener("click", removeColorHandler);
    });

    colors_variants.forEach((color_variant) => {
      color_variant.removeEventListener("click", selectColorHandler);
    });

    submit_button.removeEventListener("click", submitHandler);

    sorry_label.removeEventListener('click', sorryLabelCloseHandler);

    nailPicker.style.display = 'none';
    overlay.style.display = 'none';
  });
}

// Cart Drawer Listeners
function addCartDrawerListeners() {
  // Quantity Buttons
  document.querySelectorAll(".quantity-btn").forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const parent = button.parentElement.parentElement;
      const key = parent.parentElement.parentElement.parentElement.getAttribute("data-line-item-key");
      //const is_gifts = button.getAttribute("data-gifts");
      const is_gifts = 'false';
      const quantityInput = parent.querySelector("input");
      const buttonsContainer = parent.querySelector(".quantity-buttons-container");
      const loader = parent.querySelector(".quantity-loader");

      // Disable both the + and - buttons
      const minusButton = parent.querySelector(".quantity-minus");
      const plusButton = parent.querySelector(".quantity-plus");
      minusButton.style.pointerEvents = "none";
      plusButton.style.pointerEvents = "none";

      buttonsContainer.classList.add("hidden");
      loader.style.display = "block";

      const currentQuantity = quantityInput.value;
      const isUp = button.classList.contains("quantity-plus");
      const newQuantity = isUp ? +currentQuantity + 1 : +currentQuantity - 1;

      if (is_gifts !== 'true') {
        let updates = {
          [key]: newQuantity,
        };

        try {
          const response = await fetch(
            window.Shopify.routes.root + "cart/update.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ updates }),
            }
          );
        } finally {
          await updateCartDrawer();

          quantityInput.value = newQuantity;
          buttonsContainer.classList.remove("hidden");
          loader.style.display = "none";

          // Re-enable the buttons
          minusButton.style.pointerEvents = "all";
          plusButton.style.pointerEvents = "all";
        }
      } else {
        const productHandle = button.dataset.productHandle;
        const gifts = await getGiftsVariantIds(productHandle);

        const giftUpdates = {};
        let productUpdate = {
          [key]: newQuantity,
        };

        function getGiftCount(gift) {
          const count = gifts.filter(item => item === gift).length;
          return count;
        }
  
        const uniqueGifts = [...new Set(gifts)];
  
        for (const gift of uniqueGifts) {
          const currentGiftElement = document.querySelector(`[data-id="${gift}"]`);
          const currentGiftQuantity = currentGiftElement.dataset.quantity;
  
          const count = getGiftCount(gift);

          const newGiftQuantity = parseInt(currentGiftQuantity) - parseInt(currentQuantity) * count + newQuantity * count;
          if (newGiftQuantity <= 0) {
            giftUpdates[gift] = 0;
          } else {
            giftUpdates[gift] = newGiftQuantity;
          }
        }

        let updates = { ...productUpdate, ...giftUpdates };
        try {
          const response = await fetch(
            window.Shopify.routes.root + "cart/update.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ updates }),
            }
          );
        } finally {
          await updateCartDrawer();

          quantityInput.value = newQuantity;
          buttonsContainer.classList.remove("hidden");
          loader.style.display = "none";

          // Re-enable the buttons
          minusButton.style.pointerEvents = "all";
          plusButton.style.pointerEvents = "all";
        }
      }
    });
  });

  // Close Cart Buttons
  document.querySelectorAll(".close_cart_btn").forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();
      document.documentElement.style.overflow = "unset";
      document.getElementById("byteex_cart_drawer").style.display = "none";
    });
  });  

  // Checkout Button
  const checkout_button = document.getElementById('checkout_btn');
  if (checkout_button) {
    checkout_button.addEventListener('click', async (event) => {
      event.preventDefault();
    
      const button = event.currentTarget;
      const loader = button.querySelector('.loader');
      const text = button.querySelector('.checkout_text');

      if (loader) {
        loader.style.display = 'block';
      }

      if (text) {
        text.style.display = 'none';
      }

      await updateCartDrawer();

      const updated_button = document.getElementById('checkout_btn');
      const updated_loader = updated_button.querySelector('.loader');
      const updated_text = updated_button.querySelector('.checkout_text');

      if (updated_loader) {
        updated_loader.style.display = 'block';
      }

      if (updated_text) {
        updated_text.style.display = 'none';
      }
      
      /*const is_mystery_gift = document.getElementById('drawer-cart');
      if (!is_mystery_gift && localStorage.getItem('mg_removed') !== 'true') {
        await removeMysteryGiftsFromBrokenCart();
      }*/

      const selected_colors = document.querySelectorAll('.byteex-cart-selected-color');
      let is_empty = false;
      let empty_index;
      let empty_type;
      selected_colors.forEach((color) => {
        const empty_status = color.dataset.empty;

        if (empty_status === 'true') {
          is_empty = true;
          empty_index = color.dataset.index;
          empty_type = color.dataset.type;
        }
      });

      if (is_empty) {
        const nailPicker = document.querySelector(`.picker-${empty_index}`);

        const sorryLabel = nailPicker.querySelector('.sorry-label');
        if (sorryLabel) {
          sorryLabel.style.display = 'block';
        }

        const overlay = document.querySelector('.cart-overlay');
        nailPicker.style.display = 'block';
        overlay.style.display = 'block';

        addCartColorChangeListeners(empty_index, empty_type);
      } else {
        window.location.href = "/checkout";
      }
    });
  }

  // Delete Product from Cart
  const remove_buttons = document.querySelectorAll('.remove-cart-item');
  remove_buttons.forEach(button => {
    button.addEventListener('click', async (event) => {
      showSkeleton();
      runSpinnerLoader();

      const button = event.currentTarget;
      const id = button.dataset.key;

      let updates = {
        [id]: 0,
      };

      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      })
      .then(async () => {
        updateCartDrawer();
      })
      .catch((error) => {
        console.error('Error:', error);
      });      
    });
  });

  // Add to Cart from Upsell Slider Buttons
  const cart_upsell_atc_buttons = document.querySelectorAll('.cart-upsell-atc-button');
  cart_upsell_atc_buttons.forEach(button => {
    button.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const id = button.dataset.id;

      //const checkOutBtn = document.getElementById('checkout_btn');
      event.preventDefault();
      //checkOutBtn.disabled = true;
      //heckOutBtn.classList.add('disable-checkout');

      let formData = {
        items: [
          {
            id: id,
            quantity: 1,
          },
        ],
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
      .then((response) => {
        updateCartDrawer();
        
        const current_upsell = document.querySelector(`.cart-upsell-${id}`);
        const current_upsell_btn = current_upsell.querySelector('.cart-upsell-button');

        current_upsell.style.background = 'rgba(243, 232, 221, 1)';
        current_upsell_btn.style.background = '#fff';
        current_upsell_btn.style.color = '#000';
        current_upsell_btn.innerText = '✔ ADDED';

        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  });

  // No Thanks Buttons
  const no_thanks_buttons = document.querySelectorAll('.cart-upsell-no-button');
  const upsell_slider_container = document.querySelector('.upsell-slider-container');
  no_thanks_buttons.forEach((button, index) => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const parent = button.dataset.parent;

      const parent_element = document.querySelector(`.${parent}`);
      parent_element.style.display = 'none';

      if (index === no_thanks_buttons.length - 1) {
        upsell_slider_container.style.display = 'none';
      }
    });
  });

  // Choose Colors Buttons
  const choose_colors_buttons = document.querySelectorAll('.cart-upsell-choose-colors-button');
  choose_colors_buttons.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const choose_colors_element = button.nextElementSibling;
      choose_colors_element.style.display = 'block';

      // Choose Colors Add Buttons
      let colors_array = [];
      const choose_colors_add_buttons = choose_colors_element.querySelectorAll('.cart-upsell-color-add');
      choose_colors_add_buttons.forEach(button => {
        button.addEventListener('click', (event) => {
          const button = event.currentTarget;
          const id = button.dataset.id;
          const is_added = button.dataset.added;

          if (is_added === 'false') {
            colors_array.push(id);
            button.style.backgroundColor = '#000000';
            button.style.color = '#fff';
            button.querySelector('.cart-upsell-color-add-text').classList.add('hidden');
            button.querySelector('.cart-upsell-color-added-text').classList.remove('hidden');
            button.dataset.added = 'true';
          } else {
            button.style.backgroundColor = '#ffffff';
            button.style.color = '#000000';
            button.querySelector('.cart-upsell-color-add-text').classList.remove('hidden');
            button.querySelector('.cart-upsell-color-added-text').classList.add('hidden');
            button.dataset.added = 'false';
            colors_array = colors_array.filter(color => color !== id);
          }
        });
      });

      // Choose Colors Submit Buttons
      const choose_colors_submit_buttons = choose_colors_element.querySelectorAll('.cart-upsell-choose-colors-submit-button');
      choose_colors_submit_buttons.forEach(button => {
        button.addEventListener('click', (event) => {
          const button = event.currentTarget;
          const block_id = button.dataset.blockId;

          if (colors_array.length > 0) {
            runSpinnerLoader();

            const formData = {
              items: colors_array.map(id => ({
                id: id,
                quantity: 1
              }))
            };
      
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
            .then((response) => {
              updateCartDrawer();      
              return response.json();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }

          choose_colors_element.style.display = 'none';
          const block_element = document.querySelector(`.${block_id}`);
          block_element.style.display = 'none';
        });
      });
    });
  });  

  // Open Colors Change Buttons for Nail Picker
  const open_color_change_buttons = document.querySelectorAll('.open-color-change');
  open_color_change_buttons.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const index = button.dataset.index;
      const type = button.dataset.type;

      const nailPicker = document.querySelector(`.picker-${index}`);
      const overlay = document.querySelector('.cart-overlay');
      nailPicker.style.display = 'block';
      overlay.style.display = 'block';

      addCartColorChangeListeners(index, type);
    });
  });
}

// Skeleton Animation
function showSkeleton() {
  const skeleton = document.querySelector('.byteex-cart-drawer-items-skeleton');
  const cart_items_container = document.querySelector('.byteex-cart-drawer-items');

  if (skeleton && cart_items_container) {
    skeleton.classList.remove('hidden');
    cart_items_container.classList.add('hidden');
  }
}

function hideSkeleton() {
  const skeleton = document.querySelector('.byteex-cart-drawer-items-skeleton');
  const cart_items_container = document.querySelector('.byteex-cart-drawer-items');

  if (skeleton && cart_items_container) {
    skeleton.classList.add('hidden');
    cart_items_container.classList.remove('hidden');
  }
}

// Update Cart Items Count in Header
async function updateCartItemCount() {
  const result = await fetch("/cart.js");
  const cart = await result.json();
  const count = cart.item_count;

  const items_count_element = document.querySelector('.cart_items_counter');
  if (items_count_element) {
    items_count_element.textContent = count;
  }  
}

// Update Cart Drawer
async function updateCartDrawer() {
  try {
    showSkeleton();
    runSpinnerLoader();

    const locale = Shopify?.locale;
    const localePrefix = locale && locale !== 'en' ? `/${locale}` : '';
    const res = await fetch(`${localePrefix}/?section=a-cart-drawer-v5`);

    if (!res.ok) throw new Error(`Cart loading error: ${res.status}`);

    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;

    const newContentEl = html.querySelector(".byteex_cart_drawer");
    const currentDrawer = document.querySelector(".byteex_cart_drawer");

    if (newContentEl && currentDrawer) {
      currentDrawer.innerHTML = newContentEl.innerHTML;
      updateCartItemCount();
      addCartDrawerListeners();
    } else {
      console.warn("Could not find .byteex_cart_drawer in the new or current HTML");
    }
  } catch (error) {
    console.error("Error in updateCartDrawer:", error);
  } finally {
    const spinner_loader = document.querySelector('.spinner-loader');
    if (spinner_loader) {
      spinner_loader.classList.add('hidden');
      spinner_loader.classList.remove('flex');
    }

    hideSkeleton();
  }
}

// async function updateCartDrawer() {
//   runSpinnerLoader();

//   // To take into account the selected language - localePrefix
//   const locale = Shopify?.locale;
//   const localePrefix = locale && locale !== 'en' ? `/${locale}` : '';
//   const res = await fetch(`${localePrefix}/?section=a-cart-drawer-v5`);
  
//   const text = await res.text();
//   const html = document.createElement("div");
//   html.innerHTML = text;  

//   const newContent = html.querySelector(".byteex_cart_drawer").innerHTML;

//   document.querySelector(".byteex_cart_drawer").innerHTML = newContent;
//   updateCartItemCount();

//   addCartDrawerListeners();

//   const spinner_loader = document.querySelector('.spinner-loader');
//   spinner_loader.classList.add('hidden');
//   spinner_loader.classList.remove('flex');
// }

// Update Cart Drawer
// async function updateCartDrawer() {
//   runSpinnerLoader();

//   // To take into account the selected language - localePrefix
//   const locale = Shopify?.locale;
//   const localePrefix = locale && locale !== 'en' ? `/${locale}` : '';
//   const res = await fetch(`${localePrefix}/?section=a-cart-drawer-v5`);
  
//   const text = await res.text();
//   const html = document.createElement("div");
//   html.innerHTML = text;  

//   const newContent = html.querySelector(".byteex_cart_drawer").innerHTML;

//   const gifts_ids = html.querySelector(".data-cart-gifts-ids");
  
//   if (gifts_ids) {
//     const cart_gifts_ids = gifts_ids.dataset.cartGiftsIds;

//     if (cart_gifts_ids) {
//       const cart_gifts_ids_array = cart_gifts_ids.split(',');

//       const updates = {};
//       cart_gifts_ids_array.forEach(id => {
//         if (id) {
//           updates[id] = 0;
//         }
//       });

//       await new Promise(resolve => setTimeout(resolve, 300));

//       await fetch(window.Shopify.routes.root + 'cart/update.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ updates }),
//       })
//       .then(async (response) => {
//         updateCartItemCount();
//         const _res = await fetch(`${localePrefix}/?section=a-cart-drawer-v5`);
    
//         const _text = await _res.text();
//         const _html = document.createElement("div");
//         _html.innerHTML = _text;

//         const _newContent = _html.querySelector(".byteex_cart_drawer").innerHTML;
//         document.querySelector(".byteex_cart_drawer").innerHTML = _newContent;   
//       })
//       .catch((error) => {
//         console.error('Error:', error);
//       });
//     } else {
//       document.querySelector(".byteex_cart_drawer").innerHTML = newContent;

//       updateCartItemCount();
//     }
//   } else {
//     document.querySelector(".byteex_cart_drawer").innerHTML = newContent;
//     updateCartItemCount();
//   }

//   addCartDrawerListeners();

//   const spinner_loader = document.querySelector('.spinner-loader');
//   spinner_loader.classList.add('hidden');
//   spinner_loader.classList.remove('flex');
// }

// --------------------------------------------------------------------------

// Needs Rework after page 'At-Home Nail Manicure Kit' will be optimizated !!!
function refreshNails() {
  // Find and remove inputs with names starting with "properties["
  const inputsToRemove = document.querySelectorAll(
    'input[name^="properties["]'
  );
  inputsToRemove.forEach((input) => {
    const name = input.name;
    // check for gift for variants properties
    if (name !== 'properties[_promo]') {
      input.remove();
    }    
  });

  // disabled gift for variants input and properties
  const gift_for_variant_input = document.getElementById('gift-for-variant');
  const gift_for_variant_properties = document.getElementById('gift-for-variant-properties');
  if (gift_for_variant_input) {
    gift_for_variant_input.setAttribute('disabled', 'true');
  }
  if (gift_for_variant_properties) {
    gift_for_variant_properties.setAttribute('disabled', 'true');
  }

  const nails = document.querySelectorAll(
    ".color-selection__image--top, .color-selection__image3--top"
  );
  const atcButtons = document.querySelectorAll(".main_atc_button");

  nails.forEach((nail) => {
    nail.style.backgroundColor = "#fff";
    nail.style.backgroundImage =
      'url("https://www.sassysaints.com/cdn/shop/t/219/assets/blank_nail.png")';
    //https://www.sassysaints.com/cdn/shop/t/219/assets/blank_nail.png

    nail.classList.remove("coladded");
    nail.classList.remove("coladded2");
    nail.classList.remove("coladded3");

    const close = nail.querySelector(".selection-close");
    close.style.display = "none";

    atcButtons.forEach((button) => {
      button.style.display = "block";
      button.nextElementSibling.style.display = "none";
    });

    // const chosenItems = document.querySelectorAll('.coladded').length;
    // var newWidth = chosenItems * 25 / 2;
    const progress = document.querySelector(".progress-bar--selected");
    if (progress) {
      progress.style.width = 0;
      progress.style.backgroundColor = "#000";
    }

    const progress2 = document.querySelector(".progress-bar--selected2");
    if (progress2) {
      progress2.style.width = 0;
      progress2.style.backgroundColor = "#000";
    }

    const progress3 = document.querySelector(".progress-bar--selected3");
    if (progress3) {
      progress3.style.width = 0;
      progress3.style.backgroundColor = "#000";
    }

    const countPicked = document.querySelector(
      ".color-selection__label span.count"
    );
    if (countPicked) {
      countPicked.innerText = 0;
    }

    const countPicked2 = document.querySelector(
      ".color-selection__label2 span.count"
    );
    if (countPicked2) {
      countPicked2.innerText = 0;
    }

    const countPicked3 = document.querySelector(
      ".color-selection__label3 span.count"
    );
    if (countPicked3) {
      countPicked3.innerText = 0;
    }

    const currentCount = nail.parentElement.dataset.count;

    const text = document.querySelector(
      `.upper-grid__item[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text) {
      text.style.display = "block";
    }

    const text2 = document.querySelector(
      `.upper-grid__item2[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text2) {
      text2.style.display = "block";
    }

    const text3 = document.querySelector(
      `.upper-grid__item3[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text3) {
      text3.style.display = "block";
    }

    const titles = document.querySelectorAll(`.title${currentCount}`);
    if (titles) {
      titles.forEach((title) => (title.innerText = `Colour ${currentCount}`));
    }

    const titles2 = document.querySelectorAll(`.title2${currentCount}`);
    if (titles2) {
      titles2.forEach((title) => (title.innerText = ""));
    }

    const titles3 = document.querySelectorAll(`.title3${currentCount}`);
    if (titles3) {
      titles3.forEach((title) => (title.innerText = ""));
    }

    const heading = document.querySelector(".color-selection__heading");
    const mainHeading = document.querySelector(
      ".color-selection__main-heading"
    );
    const mainHeadingSets = document.querySelector(
      ".color-selection__main-heading_sets"
    );

    if (mainHeading) {
      mainHeading.innerHTML = "Choose Your Colours:";
      mainHeading.style.color = "#000";
    }

    if (mainHeadingSets) {
      mainHeadingSets.innerHTML = "2. Choose Your Colours:";
      mainHeadingSets.style.color = "#000";
    }

    heading.innerHTML = "Choose Your Colours:";
    heading.style.color = "#000";
  });
}

// Needs Rework after page 'Chrome Nail Kit' will be optimizated !!!
function refreshChromeNails() {
  // Find and remove inputs with names starting with "properties["
  const inputsToRemove = document.querySelectorAll(
    'input[name^="properties["]'
  );
  inputsToRemove.forEach((input) => input.remove());

  const nails = document.querySelectorAll(
    ".color-selection__image--top, .color-selection__image3--top"
  );
  const atcButtons = document.querySelectorAll(".main_atc_button");

  nails.forEach((nail) => {
    nail.style.backgroundColor = "#fff";
    nail.style.backgroundImage =
      'url("https://cdn.shopify.com/s/files/1/0396/9279/6066/files/blank_nail_double.png?v=1730889386")';

    nail.classList.remove("coladded");
    nail.classList.remove("coladded2");
    nail.classList.remove("coladded3");

    const close = nail.querySelector(".selection-close");
    close.style.display = "none";

    atcButtons.forEach((button) => {
      button.style.display = "block";
      button.nextElementSibling.style.display = "none";
    });

    // const chosenItems = document.querySelectorAll('.coladded').length;
    // var newWidth = chosenItems * 25 / 2;
    const progress = document.querySelector(".progress-bar--selected");
    if (progress) {
      progress.style.width = 0;
      progress.style.backgroundColor = "#000";
    }

    const progress2 = document.querySelector(".progress-bar--selected2");
    if (progress2) {
      progress2.style.width = 0;
      progress2.style.backgroundColor = "#000";
    }

    const progress3 = document.querySelector(".progress-bar--selected3");
    if (progress3) {
      progress3.style.width = 0;
      progress3.style.backgroundColor = "#000";
    }

    const countPicked = document.querySelector(
      ".color-selection__label span.count"
    );
    if (countPicked) {
      countPicked.innerText = 0;
    }

    const countPicked2 = document.querySelector(
      ".color-selection__label2 span.count"
    );
    if (countPicked2) {
      countPicked2.innerText = 0;
    }

    const countPicked3 = document.querySelector(
      ".color-selection__label3 span.count"
    );
    if (countPicked3) {
      countPicked3.innerText = 0;
    }

    const currentCount = nail.parentElement.dataset.count;

    const text = document.querySelector(
      `.upper-grid__item[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text) {
      text.style.display = "block";
    }

    const text2 = document.querySelector(
      `.upper-grid__item2[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text2) {
      text2.style.display = "block";
    }

    const text3 = document.querySelector(
      `.upper-grid__item3[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text3) {
      text3.style.display = "block";
    }

    const titles = document.querySelectorAll(`.title${currentCount}`);
    if (titles) {
      titles.forEach((title) => (title.innerText = ""));
    }

    const titles2 = document.querySelectorAll(`.title2${currentCount}`);
    if (titles2) {
      titles2.forEach((title) => (title.innerText = ""));
    }

    const titles3 = document.querySelectorAll(`.title3${currentCount}`);
    if (titles3) {
      titles3.forEach((title) => (title.innerText = ""));
    }

    const heading = document.querySelector(".color-selection__heading");
    const mainHeading = document.querySelector(
      ".color-selection__main-heading"
    );
    const mainHeadingSets = document.querySelector(
      ".color-selection__main-heading_sets"
    );

    if (mainHeading) {
      mainHeading.innerHTML = "Choose Your Colours:";
      mainHeading.style.color = "#000";
    }

    if (mainHeadingSets) {
      mainHeadingSets.innerHTML = "2. Choose Your Colours:";
      mainHeadingSets.style.color = "#000";
    }

    heading.innerHTML = "Choose Your Colours:";
    heading.style.color = "#000";
  });
}

// --------------------------------------------------------------------------

// Get gifts variant ids from product metafield and selected variant metafield
async function getGiftsVariantIds(productHandle, selectedVariantId) {  
  const variantIds = [];

  const query = `
    {
      product(handle: "${productHandle}") {
        metafield(namespace: "custom", key: "gifts_section_products") {
          reference {
            ... on Metaobject {
              product1: field(key: "product_1") {
                reference {
                  ... on Product {
                    variants(first: 1) {
                      edges {
                        node {
                          id
                        }
                      }
                    }
                  }
                }
              }
              product2: field(key: "product_2") {
                reference {
                  ... on Product {
                    variants(first: 1) {
                      edges {
                        node {
                          id
                        }
                      }
                    }
                  }
                }
              }
              product3: field(key: "product_3") {
                reference {
                  ... on Product {
                    variants(first: 1) {
                      edges {
                        node {
                          id
                        }
                      }
                    }
                  }
                }
              }
              product4: field(key: "product_4") {
                reference {
                  ... on Product {
                    variants(first: 1) {
                      edges {
                        node {
                          id
                        }
                      }
                    }
                  }
                }
              }
              product5: field(key: "product_5") {
                reference {
                  ... on Product {
                    variants(first: 1) {
                      edges {
                        node {
                          id
                        }
                      }
                    }
                  }
                }
              }
              product6: field(key: "product_6") {
                reference {
                  ... on Product {
                    variants(first: 1) {
                      edges {
                        node {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        variants(first: 10) {
          edges {
            node {
              id
              title
              metafield(namespace: "custom", key: "gifts") {
                reference {
                  ... on Metaobject {
                    product1: field(key: "product_1") {
                      reference {
                        ... on Product {
                          variants(first: 1) {
                            edges {
                              node {
                                id
                              }
                            }
                          }
                        }
                      }
                    }
                    product2: field(key: "product_2") {
                      reference {
                        ... on Product {
                          variants(first: 1) {
                            edges {
                              node {
                                id
                              }
                            }
                          }
                        }
                      }
                    }
                    product3: field(key: "product_3") {
                      reference {
                        ... on Product {
                          variants(first: 1) {
                            edges {
                              node {
                                id
                              }
                            }
                          }
                        }
                      }
                    }
                    product4: field(key: "product_4") {
                      reference {
                        ... on Product {
                          variants(first: 1) {
                            edges {
                              node {
                                id
                              }
                            }
                          }
                        }
                      }
                    }
                    product5: field(key: "product_5") {
                      reference {
                        ... on Product {
                          variants(first: 1) {
                            edges {
                              node {
                                id
                              }
                            }
                          }
                        }
                      }
                    }
                    product6: field(key: "product_6") {
                      reference {
                        ... on Product {
                          variants(first: 1) {
                            edges {
                              node {
                                id
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }      
    }
  `;

  try {
    const response = await fetch(`https://sassysaints.myshopify.com/api/2024-04/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": window.cart_drawer_analytics_id,
      },
      body: JSON.stringify({ query }),
    });

    const data = await response.json();
    const reference = data?.data?.product?.metafield?.reference;

    ["product1", "product2", "product3", "product4", "product5", "product6"].forEach((key) => {
      const edge = reference?.[key]?.reference?.variants?.edges?.[0];
      if (edge?.node?.id) {
        const numericId = edge.node.id.split("/").pop();
        variantIds.push(Number(numericId));
      }
    });

    if (selectedVariantId) {
      const variant = data?.data?.product?.variants?.edges?.find(edge =>
        edge.node.id.includes(selectedVariantId)
      );

      const variant_reference = variant?.node?.metafield?.reference;

      if (variant_reference) {
        ["product1", "product2", "product3", "product4", "product5", "product6"].forEach((key) => {
          const edge = variant_reference[key]?.reference?.variants?.edges?.[0];
          if (edge?.node?.id) {
            const numericId = edge.node.id.split("/").pop();
            variantIds.push(Number(numericId));
          }
        });
      }
    }

    return variantIds;

  } catch (err) {
    console.error("GraphQL error: ", err);
    return [];
  }    
}

// Add to Cart Forms from all Product Pages
// To take into account the selected language - form[action*="/cart/add"]
const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
addToCartForms.forEach((form) => {
  form.addEventListener("submit", async (event) => {
    showSkeleton();
    runSpinnerLoader();

    event.preventDefault();
    const clickedElement = event.target;
    const productType = clickedElement.dataset.productType;

    const loader = form.querySelector(".loader");
    const buttonText = form.querySelector(".atc_button_text");
    const priceAtc = form.querySelector(".price-atc"); 
    const atc_button_text = document.getElementById('atc-button-text');

    const stickyLoader = document.getElementById("sticky_atc_button_loader");
    const stickyButtonText = document.getElementById("sticky_atc_button_text");

    if (atc_button_text) {
      atc_button_text.style.display = "none";
    }

    if (priceAtc) {
      priceAtc.style.display = "none";
    }

    if (buttonText) {
      buttonText.style.display = "none";
    }

    if (loader) {
      loader.style.display = "block";
    }

    if (stickyButtonText) {
      stickyButtonText.style.display = "none";
    }

    if (stickyLoader) {
      stickyLoader.style.display = "block";
    }

    const productHandle = form.dataset.productHandle;
    const variantId = form.dataset.variantId;
    const variantIds = await getGiftsVariantIds(productHandle, variantId);
  
    // Add to cart form
    const body = new FormData(form);

    // Add gifts to the form
    variantIds.forEach((id, index) => {
      body.append(`properties[_discount_iq_gift_${index + 1}]`, id);
    });
    
    const res = await fetch("/cart/add", {
      method: "post",
      body: body,
    })
      .then(async () => {
        // Removal the data on product pages
        if (productType === "chrome") {
          refreshChromeNails();

          const submit_button = document.getElementById("byteex-submit-button");
          submit_button.querySelector(".uppercase").textContent =
            "choose your colours - (0/3)";
          submit_button.type = "button";

          const stickyATC = document.getElementById("sticky_atc");
          if (stickyATC) {
            stickyATC.style.display = "none";
          }
        } else if (productType === "value-box") {
          refreshNails();

          const submit_button = document.getElementById("byteex-submit-button");
          submit_button.querySelector(".uppercase").textContent =
            "choose your colours - (0/6)";
          submit_button.type = "button";

          const stickyATC = document.getElementById("sticky_atc");
          if (stickyATC) {
            stickyATC.style.display = "none";
          }
        } else if (productType === "at-home-nail-manicure-kit") {
          window.clearNailPicker();
        } else if (productType === "nail-picker-6-redesing") {
          window.clearNailPicker6Redesign();
        } else if (productType === "nail-picker-3-redesing") {
          window.clearNailPicker3Redesign();
        } else if (productType === "nail-picker-updated") {
          window.clearNailPickerUpdated();
        } else if (productType === "nail-picker-gel-wraps") {
          window.clearNailPickerGelWraps();
        } else if (productType === "new-nail-picker") {
          window.clearNewNailPicker();
        } else if (productType === "two-nail-picker-on-page") {
          window.clearTwoNailPickerOnPage();
        } else if (productType === "default") {
          if (atc_button_text) {
            atc_button_text.style.display = "flex";
          }
        } else {
          refreshNails();
          //remake this !!!!!!
        }        

        if (buttonText) {
          buttonText.style.display = "flex";
        }

        if (priceAtc) {
          priceAtc.style.display = "flex";
        }

        if (loader) {
          loader.style.display = "none";
        }

        if (stickyButtonText) {
          stickyButtonText.style.display = "inline";
        }

        if (stickyLoader) {
          stickyLoader.style.display = "none";
        }
        
        updateCartDrawer();

        if (
          !form.classList.contains("upsell_form") &&
          !form.classList.contains("addon_form")
        ) {
          onOpenDrawer();
        }
      })
      .catch((error) => console.error("Error adding to cart:", error));
  });
});

addCartDrawerListeners();

// Triggers a cart refresh when you navigate to a page using the browser's back button 
// (to display the real cart and not the one from the cache)
window.addEventListener('pageshow', async function(event) {
  showSkeleton();
  runSpinnerLoader();

  if (event.persisted) {
    await updateCartDrawer();
  }

  const gifts_ids = document.querySelector(".data-cart-gifts-ids");
  
  if (gifts_ids) {
    const cart_gifts_ids = gifts_ids.dataset.cartGiftsIds;

    if (cart_gifts_ids) {
      const cart_gifts_ids_array = cart_gifts_ids.split(',');

      const updates = {};
      cart_gifts_ids_array.forEach(id => {
        if (id) {
          updates[id] = 0;
        }
      });

      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      })
      .then(async () => {
        await updateCartDrawer(); 
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }

  const spinner_loader = document.querySelector('.spinner-loader');
  spinner_loader.classList.add('hidden');
  spinner_loader.classList.remove('flex');

  hideSkeleton();
});
